// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".firstPart[data-v-8b1afb46],\n.lastPart[data-v-8b1afb46] {\n  display: inline-block;\n  white-space: nowrap;\n  overflow: hidden;\n}\n.firstPart[data-v-8b1afb46] {\n  max-width: calc(100% - 2.5em);\n  min-width: 3.5em;\n  text-overflow: ellipsis;\n}\n.lastPart[data-v-8b1afb46] {\n  max-width: calc(100% - 3.5em);\n  direction: rtl;\n}\n.hash-container[data-v-8b1afb46] {\n  max-width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
